var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleEditIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66287 2.437L7.75041 3.52456M0.5 11.5H1.59823C2.48731 11.5 2.93186 11.5 3.33158 11.3344C3.73129 11.1688 4.04567 10.8545 4.67436 10.2258L10.6506 4.24961C11.0459 3.85427 11.2436 3.65663 11.3492 3.44338C11.5503 3.0377 11.5503 2.56136 11.3492 2.15566C11.2436 1.94243 11.0459 1.74477 10.6506 1.34944C10.2553 0.954112 10.0576 0.756448 9.84437 0.650782C9.43869 0.449739 8.96231 0.449739 8.55663 0.650782C8.34338 0.756448 8.14575 0.954112 7.75041 1.34944L1.77416 7.32565C1.14548 7.95433 0.831145 8.26871 0.665572 8.66845C0.5 9.06812 0.5 9.51267 0.5 10.4018V11.5Z",
    stroke: "#8790A1",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleEditIc);
export default __webpack_public_path__ + "static/media/single_edit_ic.f730bd17df667770a622e9a806cce832.svg";
export { ForwardRef as ReactComponent };